$(document).ready(function(){

  $('.m-menu').click(function(){
    $('html, body').toggleClass('noscroll');
    $('body').toggleClass('m-menu-open');
  });

  $('.faq').click(function(){
    $(this).toggleClass('open');
  });

  $('.side').click(function(){
    $(this).toggleClass('open');
    $('html, body').toggleClass('sideopen');
  });

  $('.side ul li li a').click(function(){
    $('.side ul li li a').removeClass('active');
    $('.side ul li').removeClass('subopen');
    $(this).addClass('active');
    $(this).parent().parent().parent().addClass('subopen');
  });

  $('.arrowed-link span').click(function(e){
    e.preventDefault();
    e.stopPropagation();
    var parent = $(this).parent().parent();
    // console.log(parent.hasClass('active'))
    if(parent.hasClass('subopen')){
      parent.removeClass('subopen')
    }else{
      parent.addClass('subopen')
    }
  });

  $('.side ul li li a').each(function(){
    var myurl = $(this).attr('href');
    if(myurl == window.location.href){
      $(this).addClass('active');
      $(this).parent().parent().parent().addClass('subopen');
    }
  })
  $('.side ul li .arrowed-link a').each(function(){
    var myurl = $(this).attr('href');
    if(myurl == window.location.href){
      $(this).parent().parent().addClass('subopen');
    }
  })


  $('.embed').fitVids();

  $('.shortcuts .upper .row').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.shortcuts .lower .row',
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });
  $('.shortcuts .lower .row').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.shortcuts .upper .row',
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });

  $('#themeselect').change(function(){
    var val = $(this).val();
    if(val != undefined){
      window.location = val
    }

  });
/*
  $(window).resize(function(){
  	var height = $('header.header').height(); //take the header height
  	$('main.main').css({'margin-top':height}); //alter the margin of the wrapped content
  }).trigger('resize');//trigger the margin resize when page is loaded
*/
});